import { isStringExactMatch } from '@/utils/common';
import { getApiMethod } from '@/modules/apiSelector';

export default {
  namespaced: true,
  state: {
    trainerTags: [],
    tagItems: [],
    editTag: null
  },
  mutations: {
    setTagItems(state, payload) {
      state.tagItems = payload;
    },
    addTrainerTags(state, payload) {
      state.trainerTags.push(payload);
    },
    setTrainerTags(state, payload) {
      state.trainerTags = payload;
    },
    setEditTag(state, payload) {
      state.editTag = payload;
    }
  },
  actions: {
    /**
     * Save/Update tagged word(s)/phrase(s)
     *
     * @param {commit} commit
     * @param {object} message
     * @return {object} data of tagged word(s)/phrase(s)
     */

    async saveTrainerTag({ commit, state }, message) {
      const params = {
        lesson_id: this.state.lessonId,
        message_id: message.id
      };

      const data = state.trainerTags
        // filter exact tagged words not included on chat message
        .filter(tag => isStringExactMatch(message.text, tag.word.trimEnd()) || tag.tagged_word_id)
        .map(finalTag => {
          return {
            ...finalTag,
            ...params,
            tagged_word_id: finalTag.tagged_word_id || message.tagWordId,
            tag_ids: isStringExactMatch(message.text, finalTag.word) ? finalTag.tag_ids : null
          };
        });

      if (!data.length) {
        commit('setTrainerTags', []);
        return;
      }

      let responseData;
      const apiMethod = getApiMethod('storeTrainerTag');
      await apiMethod(data, (data) => {
        commit('setTrainerTags', []);
        responseData = data;
      });

      return responseData;
    }
  }
};
